import { render, staticRenderFns } from "./KanbanView.vue?vue&type=template&id=15767133&scoped=true"
import script from "./KanbanView.vue?vue&type=script&lang=js"
export * from "./KanbanView.vue?vue&type=script&lang=js"
import style0 from "./KanbanView.vue?vue&type=style&index=0&id=15767133&prod&lang=css"
import style1 from "./KanbanView.vue?vue&type=style&index=1&id=15767133&prod&lang=css"
import style2 from "./KanbanView.vue?vue&type=style&index=2&id=15767133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15767133",
  null
  
)

export default component.exports